<div id="coordinator-video-wrapper">
    <div id="coordinator-video-splash-screen">
        Wait for connection
    </div>
    <div class="coordinator-video" hidden="true">
        <img src="assets/icons/nq-5.png" id="coordinator-network-quality" />
    </div>
</div>

